import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { createCompany } from "../../../slices/admin/companySlice";

const AdminAddCompany = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        company_name: '',
        user_name: '',
        email: '',
        mobile_no: '',
        password: '',
        confirm_password: '',
        trade: '',
        company_type: '',
        company_pan_numer: '',
        doi: '',
        register_address: '',
        gst_number: '',
        nature_of_business: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('Submitting:', formData);
        try {
            await dispatch(createCompany(formData)).unwrap(); // Using unwrap for better error handling
            navigate('/admin/companies');
        } catch (error) {
            console.error('Failed to create company:', error);
        }
    };

    return (
        <div className="row">
            <div className="col-xl-12 col-xxl-12">
                <div className="card">
                    <div className="card-header">
                        <h4 className="card-title">Add Company</h4>
                    </div>
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-lg-6 mb-2">
                                    <div className="form-group">
                                        <label className="text-label">Company Name*</label>
                                        <input
                                            type="text"
                                            name="company_name"
                                            value={formData.company_name}
                                            onChange={handleChange}
                                            className="form-control"
                                            placeholder="Company Name"
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6 mb-2">
                                    <div className="form-group">
                                        <label className="text-label">User Name*</label>
                                        <input
                                            type="text"
                                            name="user_name"
                                            value={formData.user_name}
                                            onChange={handleChange}
                                            className="form-control"
                                            placeholder="User Name"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="col-lg-6 mb-2">
                                    <div className="form-group">
                                        <label className="text-label">Email Address*</label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            className="form-control"
                                            placeholder="example@example.com"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="col-lg-6 mb-2">
                                    <div className="form-group">
                                        <label className="text-label">Mobile Number*</label>
                                        <input
                                            type="text"
                                            name="mobile_no"
                                            value={formData.mobile_no}
                                            onChange={handleChange}
                                            className="form-control"
                                            placeholder="(+1)408-657-9007"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="col-lg-6 mb-2">
                                    <div className="form-group">
                                        <label className="text-label">Password*</label>
                                        <input
                                            type="password"
                                            name="password"
                                            value={formData.password}
                                            onChange={handleChange}
                                            className="form-control"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="col-lg-6 mb-2">
                                    <div className="form-group">
                                        <label className="text-label">Confirm Password*</label>
                                        <input
                                            type="password"
                                            name="confirm_password"
                                            value={formData.confirm_password}
                                            onChange={handleChange}
                                            className="form-control"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="col-lg-6 mb-2">
                                    <div className="form-group">
                                        <label className="text-label">Trade*</label>
                                        <input
                                            type="text"
                                            name="trade"
                                            value={formData.trade}
                                            onChange={handleChange}
                                            className="form-control"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="col-lg-6 mb-2">
                                    <div className="form-group">
                                        <label className="text-label">Company Type*</label>
                                        <input
                                            type="text"
                                            name="company_type"
                                            value={formData.company_type}
                                            onChange={handleChange}
                                            className="form-control"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="col-lg-6 mb-2">
                                    <div className="form-group">
                                        <label className="text-label">Company PAN Number*</label>
                                        <input
                                            type="text"
                                            name="company_pan_number"
                                            value={formData.company_pan_number}
                                            onChange={handleChange}
                                            className="form-control"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="col-lg-6 mb-2">
                                    <div className="form-group">
                                        <label className="text-label">Date of Incorporation*</label>
                                        <input
                                            type="date"
                                            name="doi"
                                            value={formData.doi}
                                            onChange={handleChange}
                                            className="form-control"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="col-lg-12 mb-2">
                                    <div className="form-group">
                                        <label className="text-label">Registered Address*</label>
                                        <input
                                            type="text"
                                            name="register_address"
                                            value={formData.register_address}
                                            onChange={handleChange}
                                            className="form-control"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="col-lg-6 mb-2">
                                    <div className="form-group">
                                        <label className="text-label">GST Number*</label>
                                        <input
                                            type="text"
                                            name="gst_number"
                                            value={formData.gst_number}
                                            onChange={handleChange}
                                            className="form-control"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="col-lg-6 mb-2">
                                    <div className="form-group">
                                        <label className="text-label">Nature of Business*</label>
                                        <input
                                            type="text"
                                            name="nature_of_business"
                                            value={formData.nature_of_business}
                                            onChange={handleChange}
                                            className="form-control"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <button type="submit" className="btn btn-primary btn-block">
                                        Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default AdminAddCompany;